module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-backoffice-create-vehicle-slot"
  }, [_c('modal-reveal', {
    ref: "createVehicleSlotModal",
    attrs: {
      "sizing": "small"
    }
  }, [_c('button', {
    staticClass: "button small",
    attrs: {
      "slot": "trigger"
    },
    slot: "trigger"
  }, [_vm._v("Archive Slot")]), _c('h2', [_vm._v("Archive")]), _c('p', [_vm._v("Select where to move all past reservations of vehicle slots associated to this parking slot")]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('selectize-grouped-parking-assets', {
    on: {
      "parkingSlotSelected": _vm.setParkingSlot
    }
  })], 1)]), _c('div', {
    staticClass: "row column"
  }, [_c('button', {
    staticClass: "button",
    attrs: {
      "disabled": _vm.parkingSlot === null
    },
    on: {
      "click": _vm.archive
    }
  }, [_vm._v("Archive")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-687c2ed0!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/actions/asset-management/ArchiveVehicleSlots.vue
// module id = 2547
// module chunks = 1